import { render, staticRenderFns } from "./TopicFileView.vue?vue&type=template&id=453c25cd&scoped=true"
import script from "./TopicFileView.vue?vue&type=script&lang=js"
export * from "./TopicFileView.vue?vue&type=script&lang=js"
import style0 from "./TopicFileView.vue?vue&type=style&index=0&id=453c25cd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c25cd",
  null
  
)

export default component.exports